/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { DisplayedProfile } from './';
import {
    DisplayedProfileFromJSON,
    DisplayedProfileFromJSONTyped,
    DisplayedProfileToJSON,
} from './';

/**
 * 
 * @export
 * @interface RejectFreelancersRequest
 */
export interface RejectFreelancersRequest {
    /**
     * 
     * @type {string}
     * @memberof RejectFreelancersRequest
     */
    advancedSearchQueryId: string;
    /**
     * 
     * @type {Array<DisplayedProfile>}
     * @memberof RejectFreelancersRequest
     */
    profiles: Array<DisplayedProfile>;
}

/**
 * Check if a given object implements the RejectFreelancersRequest interface.
 */
export function instanceOfRejectFreelancersRequest(value: object): value is RejectFreelancersRequest {
    if (!('advancedSearchQueryId' in value) || value['advancedSearchQueryId'] === undefined) return false;
    if (!('profiles' in value) || value['profiles'] === undefined) return false;
    return true;
}

export function RejectFreelancersRequestFromJSON(json: any): RejectFreelancersRequest {
    return RejectFreelancersRequestFromJSONTyped(json, false);
}

export function RejectFreelancersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectFreelancersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'advancedSearchQueryId': json['advancedSearchQueryId'],
        'profiles': ((json['profiles'] as Array<any>).map(DisplayedProfileFromJSON)),
    };
}

export function RejectFreelancersRequestToJSON(value?: RejectFreelancersRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'advancedSearchQueryId': value['advancedSearchQueryId'],
        'profiles': ((value['profiles'] as Array<any>).map((v) => DisplayedProfileToJSON(v))),
    };
}

